import { render, staticRenderFns } from "./insurance_services.vue?vue&type=template&id=5179ea4b&scoped=true&"
import script from "./insurance_services.vue?vue&type=script&lang=js&"
export * from "./insurance_services.vue?vue&type=script&lang=js&"
import style0 from "./insurance_services.vue?vue&type=style&index=0&id=5179ea4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5179ea4b",
  null
  
)

export default component.exports